import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.474 3.684V3a1 1 0 012 0v.684h5.158V3a1 1 0 112 0v.684h.894a2.79 2.79 0 012.79 2.79v4.67a6.017 6.017 0 00-2-.105v-.776H4v6.947c0 .437.353.79.79.79h6.293c.12.718.368 1.393.72 2H4.789A2.79 2.79 0 012 17.21V6.474a2.79 2.79 0 012.79-2.79h.684zm10.842 4.58H4v-1.79a.79.79 0 01.79-.79h10.736a.79.79 0 01.79.79v1.79zM22 17a5 5 0 10-10 0 5 5 0 0010 0zm-5.492-2.59a.5.5 0 01.992.09v2.295l1.6 1.6.056.078a.5.5 0 01-.756.632l-1.75-1.75-.052-.06A.5.5 0 0116.5 17v-2.5l.008-.09z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
